import { BaseModel } from './base';

export class Priority extends BaseModel {
  priorityId: string;
  priorityName: string;
  SubscriberId: string;
  SiteId: string;
  Status: string;
  id: string;
}